'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _base = require('base');

var _base2 = _interopRequireDefault(_base);

var _jQuery = require('jQuery');

var _jQuery2 = _interopRequireDefault(_jQuery);

var _classList = require('class-list');

var _classList2 = _interopRequireDefault(_classList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TextField = function (_BaseField) {
	_inherits(TextField, _BaseField);

	function TextField() {
		_classCallCheck(this, TextField);

		return _possibleConstructorReturn(this, (TextField.__proto__ || Object.getPrototypeOf(TextField)).apply(this, arguments));
	}

	_createClass(TextField, [{
		key: 'render',
		value: function render() {
			var _this2 = this;

			var style = this.props.textSuffix ? { position: 'relative' } : {};

			var extra = {};
			if (this.props.numeric) {
				extra = {
					onKeyDown: function onKeyDown(event) {
						var tgtValue = Number(_this2.getValue());
						if (event.key == 'ArrowUp') {
							tgtValue += _this2.props.step;
							event.preventDefault();
						} else if (event.key == 'ArrowDown') {
							tgtValue -= _this2.props.step;
							event.preventDefault();
						} else return;

						tgtValue = Math.max(_this2.props.minValue || 0, tgtValue);
						tgtValue = Math.min(_this2.props.maxValue || +Infinity, tgtValue);
						var x = _this2.props.step.toString();
						var xp = x.indexOf('.');
						var dp;
						if (xp == -1) {
							dp = 0;
						} else {
							dp = x.length - (xp + 1);
						}
						tgtValue = tgtValue.toFixed(dp);
						if (dp) {
							if (tgtValue.split('.').pop().replace(/0/g, '').length == 0) tgtValue = tgtValue.split('.').shift();
						}
						if (tgtValue != _this2.getValue()) _this2.updateValue(tgtValue);
					}
				};
			}

			if (this.props.inputClassName) {
				extra.className = this.props.inputClassName;
			}

			return React.createElement(
				'label',
				{ ref: function ref(node) {
						return _this2.rootNode = node;
					}, style: style, className: _classList2.default.join(this.props.asRow ? 'label-row' : '', this.props.className || void 0) },
				React.createElement(
					'span',
					{ className: this.props.labelOutside || this.props.asRow ? '' : 'sr-only' },
					this.props.label
				),
				React.createElement('input', _extends({ placeholder: this.props[this.props.labelOutside || this.props.asRow ? 'placeholder' : 'label'], type: this.type, value: this.getValue(), onBlur: function onBlur() {
						return _this2.commitValue();
					}, onChange: function onChange(event) {
						return _this2.updateValue(_this2.processValue(event.target.value));
					} }, extra)),
				this.props.textSuffix ? React.createElement('div', { className: 'textSuffixWrapper', ref: function ref(node) {
						return _this2.setTextSuffix(node);
					} }) : null
			);
		}
	}, {
		key: 'componentDidMount',
		value: function componentDidMount() {
			if (this.props.autoFocus) {
				this.rootNode.querySelector('input').focus();
			}
			// This is a tweak for Safari
			var rn = this.rootNode.querySelector('input');
			var ph = rn.placeholder;
			rn.placeholder = '';
			requestAnimationFrame(function () {
				return rn.placeholder = ph;
			});
		}
	}, {
		key: 'processValue',
		value: function processValue(value) {
			if (value == "") return value;

			if (this.props.numeric) {
				var tgtValue = Number(value);
				if (isNaN(tgtValue)) tgtValue = this.getValue();
				if (tgtValue < this.props.minValue) tgtValue = this.props.minValue;
				if (tgtValue > this.props.maxValue) tgtValue = this.props.maxValue;
				if (tgtValue != value) return tgtValue;
			}
			return value;
		}
	}, {
		key: 'updateValue',
		value: function updateValue(value) {
			var _get2;

			for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
				args[_key - 1] = arguments[_key];
			}

			(_get2 = _get(TextField.prototype.__proto__ || Object.getPrototypeOf(TextField.prototype), 'updateValue', this)).call.apply(_get2, [this, value].concat(args));
			if (this.textSuffixNode) {
				this.textSuffixNode.querySelector('.textSizer').textContent = value;
				this.updatePosition();
			}
		}
	}, {
		key: 'setTextSuffix',
		value: function setTextSuffix(node) {
			var _this3 = this;

			if (node === this.textSuffixNode) return;

			this.textSuffixNode = node;

			if (node) {
				node.innerHTML = '<div style="position: absolute; top: 0; left: 0;">\n\t\t\t\t<div class=\'textSizer\' style=\'position: fixed; top: -10000px; left: -10000px;\'></div>\n\t\t\t\t<div class=\'suffixText\'></div>\n\t\t\t</div>';
				node.querySelector('.textSizer').textContent = this.getValue();
				node.querySelector('.suffixText').textContent = this.props.textSuffix;
				if ((0, _jQuery2.default)(node).parents('.modal:not(.in)').length) {
					(0, _jQuery2.default)(node).parents('.modal').one('showing.bs.modal', function (event) {
						_this3.updatePosition();
					});
				}
				this.updatePosition();
			}
		}
	}, {
		key: 'updatePosition',
		value: function updatePosition() {
			try {
				this.textSuffixNode.querySelector('.suffixText').style.cssText = '\n\t\t\t\tleft: ' + this.textSuffixNode.querySelector('.textSizer').offsetWidth + 'px;\n\t\t\t';
			} catch (e) {
				;
			}
		}
	}, {
		key: 'type',
		get: function get() {
			return this.props.type || 'text';
		}
	}]);

	return TextField;
}(_base2.default);

exports.default = TextField;